export default "__VITE_ASSET__DVC2qNgw__"